<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { generateUUID } from '@common/utils/strings';

  export let row = {};

  const id = `tooltip-${generateUUID()}`;
</script>

{#if row.active}
  {#if new Date(row?.schedule?.startDate).getTime() >= new Date().getTime()}
    <div {id} class="badge-upcoming">{$format('label.CAMPAIGN_UPCOMING')}</div>
    <Tooltip target={id}>{$format('label.TOOLTIP.CAMPAIGN_UPCOMING_AND_SCHEDULED')}</Tooltip>
  {:else}
    <div {id} class="badge-active">{$format('label.ACTIVE')}</div>
    <Tooltip target={id}>{$format('label.TOOLTIP.CAMPAIGN_ACTIVE_AND_SCHEDULED')}</Tooltip>
  {/if}
{:else if row.paused}
  <div class="badge-paused">{$format('label.PAUSED')}</div>
{:else if row.notscheduled && row.targetingSources}
  <div {id} class="badge-notscheduled">{$format('label.ACTIVE')}</div>
  <Tooltip target={id}>
    {$format('label.TOOLTIP.CAMPAIGN_ACTIVE_AND_NOT_SCHEDULED')}

    {#if row?.targetingSources}
      <br /><br />
      <div>
        <div class="targeting-criteria">
          {#if row.targetingSources.recipient && (row.targetingSources.recipient.tags.length || row.targetingSources.recipient.campaigns.length)}
            <div>
              <b>{$format('label.TARGETING')} &rarr; {$format('label.RECIPIENT')}</b>
              {#if row.targetingSources.recipient.tags.length}
                <div>{$format('label.TAGS')}: {row.targetingSources.recipient.tags.join(', ')}</div>
              {/if}
              {#if row.targetingSources.recipient.campaigns.length}
                <div>{$format('label.RECIPIENTS')}: {row.targetingSources.recipient.campaigns.join(', ')}</div>
              {/if}
            </div>
          {/if}

          {#if row.targetingSources.domain && (row.targetingSources.domain.tags.length || row.targetingSources.domain.campaigns.length)}
            <div>
              <b>{$format('label.TARGETING')} &rarr; {$format('label.DOMAIN')}</b>
              {#if row.targetingSources.domain.tags.length}
                <div>{$format('label.TAGS')}: {row.targetingSources.domain.tags.join(', ')}</div>
              {/if}
              {#if row.targetingSources.domain.campaigns.length}
                <div>{$format('label.DOMAINS')}: {row.targetingSources.domain.campaigns.join(', ')}</div>
              {/if}
            </div>
          {/if}

          {#if row.targetingSources.group && (row.targetingSources.group.tags.length || row.targetingSources.group.campaigns.length)}
            <div>
              <b>{$format('label.TARGETING')} &rarr; {$format('label.GROUP')}</b>
              {#if row.targetingSources.group.tags.length}
                <div>{$format('label.TAGS')}: {row.targetingSources.group.tags.join(', ')}</div>
              {/if}
              {#if row.targetingSources.group.campaigns.length}
                <div>{$format('label.CAMPAIGNS')}: {row.targetingSources.group.campaigns.join(', ')}</div>
              {/if}
            </div>
          {/if}

          {#if row.targetingSources.campaigns && row.targetingSources.campaigns.tags.length}
            <div>
              <b>{$format('label.TARGETING')} &rarr; {$format('label.CAMPAIGNS')}</b>
              {#if row.targetingSources.campaigns.tags.length}
                <div>{$format('label.TAGS')}: {row.targetingSources.campaigns.tags.join(', ')}</div>
              {/if}
            </div>
          {/if}

          {#if row.targetingSources.signatures && row.targetingSources.signatures.campaigns.length}
            <div>
              <b>{$format('label.TARGETING')} &rarr; {$format('label.SIGNATURES')}</b>
              {#if row.targetingSources.signatures.campaigns.length}
                <div>
                  {$format('label.SIGNATURES')}: {row.targetingSources.signatures.campaigns.join(', ')}
                </div>
              {/if}
            </div>
          {/if}
          {#if row.targetingSources.integrations && row.targetingSources.integrations.campaigns.length}
            <div>
              <b>{$format('label.TARGETING')} &rarr; {$format('label.INTEGRATIONS')}</b>
              {#if row.targetingSources.integrations.campaigns.length}
                <div>
                  {$format('label.PLUGINS')}: {row.targetingSources.integrations.campaigns
                    .map(({ provider }) => provider)
                    .join(', ')}
                </div>
              {/if}
            </div>
          {/if}
        </div>
      </div>
    {/if}
  </Tooltip>
{:else if row.completed && row.scheduled}
  <div class="badge-expired">{$format('label.CAMPAIGN_EXPIRED')}</div>
{:else}
  <div class="badge-inactive">{$format('label.INACTIVE')}</div>
{/if}

<style lang="scss">
  .badge-active,
  .badge-paused,
  .badge-notscheduled,
  .badge-expired,
  .badge-inactive,
  .badge-upcoming {
    background-color: var(--color-blue-400);
    border: 1px solid var(--color-blue-400);
    border-radius: var(--border-radius-base);
    display: inline-block;
    font-size: var(--font-size-small);
    padding: var(--padding-small) var(--padding-base);
    text-transform: uppercase;
    white-space: nowrap;
  }

  .badge-paused {
    background-color: var(--color-orange-100);
    border: 1px solid var(--color-orange-100);
    color: var(--color-text);
  }

  .badge-notscheduled {
    background-color: var(--color-blue-0);
    border: 1px solid var(--color-blue-0);
    color: var(--color-gray-900);
  }

  .badge-expired {
    background-color: var(--color-red-300);
    border: 1px solid var(--color-red-300);
  }

  .badge-inactive {
    background-color: transparent;
    border: 1px solid var(--color-gray-600);
    color: var(--color-gray-900);
  }

  .badge-upcoming {
    background-color: var(--color-yellow-100);
    border: 1px solid var(--color-yellow-100);
    color: var(--color-gray-900);
  }

  .targeting-criteria {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
</style>
